// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1Ha8N","visuallyhidden":"le_2H","hide-text":"_1z26u","center":"_1YFWz","noprint":"_5BiMw","root":"wYxDJ","text":"_2o83_"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-blockquote/styles/sports.scss
 ** module id = 988
 ** module chunks = 2
 **/